import { Router } from '@angular/router';
import { FlowAccessService } from '../_services/flow-access.service';
import { environment } from 'src/environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "../_services/flow-access.service";
import * as i2 from "@angular/router";
export class FlowNavigationGuard {
    constructor(flow, router) {
        this.flow = flow;
        this.router = router;
    }
    canActivate(route, state) {
        const id = route.paramMap.get('id');
        return this.check(state.url, id);
    }
    check(url, id) {
        if (this.flow.consume(url)) {
            return true;
        }
        this.router.navigate(['/', environment.defaultLang, 'service-details', id ? id : '']);
        return false;
    }
}
FlowNavigationGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function FlowNavigationGuard_Factory() { return new FlowNavigationGuard(i0.ɵɵinject(i1.FlowAccessService), i0.ɵɵinject(i2.Router)); }, token: FlowNavigationGuard, providedIn: "root" });
